import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.4.7_@babel+core@7.26.0_@opentelemetry+api@1.9.0_@playwright+test@1.51.1_react-dom@19._n6w23kjade5fbvvj4wrlefn4n4/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui/src/link.tsx");
